import { toast } from 'react-toastify';
import { useGenerateInviteLinkMutation } from '../slices/userApiSlice';
import { BiRefresh } from 'react-icons/bi';
import { LuClipboardCopy } from 'react-icons/lu';

type GenerateInviteLinkProps = {
  email: string;
  extraClassName?: string;
};
const GenerateInviteLink = ({ email, extraClassName }: GenerateInviteLinkProps) => {
  const [getInviteLink, { isLoading }] = useGenerateInviteLinkMutation();
  return (
    <span
      className={`items-center flex btn red text-center w-full m-auto ${extraClassName ?? ''}`}
      onClick={async () => {
        const data = await getInviteLink({ email });
        if ('data' in data)
          navigator.clipboard
            .writeText(data.data.url)
            .then(() => {
              toast.success('URL copied to clipboard', {
                position: toast.POSITION.TOP_CENTER,
              });
            })
            .catch((error) => {
              toast.error('Failed to copy to clipboard', {
                position: toast.POSITION.TOP_CENTER,
              });
            });
      }}
    >
      <LuClipboardCopy color='white' className={`text-xl mr-2`} />
      Copy Link
    </span>
  );
};

export default GenerateInviteLink;
